import { createRouter, Router } from '@tanstack/react-router';

import { NotFound } from '@mint-emails/recommendation/routes';

import { context } from './context/router-context.js';
import { routeTree } from './routeTree.gen.js';

export * from '@tanstack/react-router';

export type EmailsRouter = Router<typeof routeTree, 'preserve', boolean>;
export const routerContext = context;

const routerInstance = createRouter({
  context,
  routeTree,
  trailingSlash: 'preserve',

  defaultNotFoundComponent: NotFound,
});

export { routerInstance };

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof routerInstance;
  }
}
